/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Transaction } from "./Transaction";
import * as t from "io-ts";

// required attributes
const TransactionResponseR = t.interface({});

// optional attributes
const TransactionResponseO = t.partial({
  data: Transaction
});

export const TransactionResponse = t.intersection(
  [TransactionResponseR, TransactionResponseO],
  "TransactionResponse"
);

export type TransactionResponse = t.TypeOf<typeof TransactionResponse>;
